export function cookie() {
  document.addEventListener("DOMContentLoaded", (event) => {
    const popup = document.getElementById("cookiePopup");
    const acceptButton = document.getElementById("acceptButton");
    const denyButton = document.getElementById("denyButton");

    if (!localStorage.getItem("cookieConsent")) {
      setTimeout(() => {
        popup.style.transform = "translateY(0)";
      }, 2500);
    }

    acceptButton.addEventListener("click", acceptCookies);
    denyButton.addEventListener("click", denyCookies);
  });

  function acceptCookies() {
    const popup = document.getElementById("cookiePopup");
    popup.style.transform = "translateY(100%)";
    localStorage.setItem("cookieConsent", "accept");
  }

  function denyCookies() {
    const popup = document.getElementById("cookiePopup");
    popup.style.transform = "translateY(100%)";
    localStorage.setItem("cookieConsent", "deny");

    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
  }
}
